import React, { useEffect, useState } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Service from "./webservice/http";
import { useHistory } from "react-router-dom";
import "react-rangeslider/lib/index.css";
import RangeSlider from "rsuite/RangeSlider";
import "rsuite/dist/rsuite.min.css";
import { storage } from "./utils/storage";

const ROLE_LEVEL = {
  Management: 0,
  LOB: 1,
  Manager: 2,
  Managerh: 2,
  "Master Collections": 2,
  "Team Lead": 3,
};

const AGENT_ROLES = ["Agent Collections", "Agenth", "Agent", "DCA Agent"];

const HIERARCHY_FIELDS = [
  {
    key: "organization",
    label: "Organization",
    minLevel: 0,
    apiField: "lob_name",
  },
  { key: "manager", label: "Manager", minLevel: 1, apiField: "manager_name" },
  {
    key: "team_lead",
    label: "Team Lead",
    minLevel: 2,
    apiField: "team_lead_name",
  },
  { key: "agent", label: "Agent", minLevel: 3, apiField: "agent_name" },
];

const CARD_STYLE = {
  backgroundColor: "#fff",
  borderRadius: "6px",
  padding: "12px 14px",
  marginBottom: "10px",
  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
};

const CARD_HEADING_STYLE = {
  fontWeight: "700",
  color: "#271078",
  borderBottom: "2px solid #271078",
  paddingBottom: "6px",
  marginBottom: "10px",
  marginTop: "0",
};

const SELECT_STYLE = {
  width: "100%",
  padding: "6px 10px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  backgroundColor: "#fff",
  color: "#333",
  marginBottom: "10px",
};

const SelectField = ({ label, filterKey, options, value, onChange }) => (
  <div className="" style={{ paddingBottom: "1px" }}>
    <div className="my-calls-column">
      <div className="row">
        <div className="col-md-6">
          <div className="form-col clearfix">
            <p className="blue">{label}</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 px-8">
          <select
            value={value}
            onChange={(e) => onChange(filterKey, e.target.value)}
            style={SELECT_STYLE}
          >
            <option value="">-- All --</option>
            {options &&
              options.map((opt) => (
                <option
                  key={opt.id || opt.value || opt.name || opt}
                  value={opt.name || opt.value || opt}
                >
                  {opt.name || opt.label || opt}
                </option>
              ))}
          </select>
        </div>
      </div>
    </div>
  </div>
);

const Filter = (props) => {
  const history = useHistory();
  const services = new Service();
  const userRole = (storage.getItem("role") || "").trim();
  // console.log("[Filter] userRole from storage:", JSON.stringify(userRole));
  const isAgentRole = AGENT_ROLES.includes(userRole);

  const loggedLevel = ROLE_LEVEL[userRole] ?? 99;
  const visibleHierarchyFields = HIERARCHY_FIELDS.filter(
    (f) => loggedLevel <= f.minLevel,
  );

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const formatDate = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const [filterData, setFilterData] = useState(null);

  const [agentSelectedFilters, setAgentSelectedFilters] = useState({
    agent: [],
    customer: [],
    product: [],
    sentiment: [],
    intent: [],
    pitch_variance: [],
    aggreeability: null,
    loudness: null,
    start_date: null,
    end_date: null,
  });

  const handleAgentDateRangeSelect = (ranges) => {
    setSelectionRange(ranges.selection);
    setAgentSelectedFilters((prev) => ({
      ...prev,
      start_date: ranges.selection.startDate,
      end_date: ranges.selection.endDate,
    }));
  };

  const handleCheckboxChange = (category, value) => {
    setAgentSelectedFilters((prev) => {
      const updated = prev[category].includes(value)
        ? prev[category].filter((item) => item !== value)
        : [...prev[category], value];
      return { ...prev, [category]: updated };
    });
  };

  const handleSliderChange = (category, value) => {
    setAgentSelectedFilters((prev) => ({
      ...prev,
      [category]: { min: value[0], max: value[1] },
    }));
  };

  const handleAgentApply = () => {
    const formattedFilters = {};
    if (agentSelectedFilters.start_date)
      formattedFilters.from_date = formatDate(agentSelectedFilters.start_date);
    if (agentSelectedFilters.end_date)
      formattedFilters.to_date = formatDate(agentSelectedFilters.end_date);
    if (agentSelectedFilters.product.length > 0)
      formattedFilters.product = agentSelectedFilters.product;
    if (agentSelectedFilters.agent.length > 0)
      formattedFilters.agent = agentSelectedFilters.agent;
    if (agentSelectedFilters.customer.length > 0)
      formattedFilters.customer = agentSelectedFilters.customer;
    if (agentSelectedFilters.sentiment.length > 0)
      formattedFilters.sentiment = agentSelectedFilters.sentiment;
    if (agentSelectedFilters.intent.length > 0)
      formattedFilters.intent = agentSelectedFilters.intent;
    if (agentSelectedFilters.pitch_variance.length > 0)
      formattedFilters.pitch_variance = agentSelectedFilters.pitch_variance;
    if (agentSelectedFilters.aggreeability)
      formattedFilters.aggreeability = agentSelectedFilters.aggreeability;
    if (agentSelectedFilters.loudness)
      formattedFilters.loudness = agentSelectedFilters.loudness;

    props.changeSideBarWidth();
    if (props.onApplyFilter) props.onApplyFilter(formattedFilters);
  };

  const handleAgentReset = () => {
    setAgentSelectedFilters({
      agent: [],
      product: [],
      customer: [],
      sentiment: [],
      intent: [],
      pitch_variance: [],
      aggreeability: null,
      loudness: null,
      start_date: null,
      end_date: null,
    });
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    });
    props.changeSideBarWidth();
    if (props.onresetFilter) props.onresetFilter();
  };

  const [apiFilters, setApiFilters] = useState({
    lob: [],
    manager: [],
    teamLead: [],
    agent: [],
    dcaOrganization: [],
    collectionStrategy: [],
  });

  const fetchGlobalFilters = async () => {
    try {
      const res = await services.get(
        "api/call_verification/hierarchy-filters/",
      );
      if (res && res.filters) {
        const f = res.filters;
        setApiFilters({
          lob: f.organization_filters?.lob || [],
          manager: f.organization_filters?.manager_collections || [],
          teamLead: f.organization_filters?.team_lead || [],
          agent: f.organization_filters?.agent || [],
          dcaOrganization: f.dca_filters?.dca_organization || [],
          collectionStrategy: f.campaign_filters?.collection_strategy || [],
        });
      }
    } catch (err) {
      console.error("Failed to fetch global filters:", err);
    }
  };

  function fetchFilter() {
    services.get(`api/filter/manage/${props.filterType}/`).then((res) => {
      if (res === "TypeError: Failed to fetch") return;
      if (res.code === "token_not_valid") {
        storage.clear();
        history.push("/login");
      }
      setFilterData(res);
      if (res && res.aggreability && res.loudness) {
        try {
          setAgentSelectedFilters((prev) => ({
            ...prev,
            aggreeability: {
              min: res.aggreability.min || 0,
              max: res.aggreability.max || 500,
            },
            loudness: {
              min: res.loudness.min || 35,
              max: res.loudness.max || 40,
            },
          }));
        } catch (e) {
          console.error("Error setting filter data:", e);
        }
      }
    });
  }

  useEffect(() => {
    fetchFilter();
    fetchGlobalFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const EMPTY_MGR_FILTERS = {
    lob_name: "",
    manager_name: "",
    team_lead_name: "",
    agent_name: "",
    dca_organization_name: "",
    collection_strategy: "",
    start_date: null,
    end_date: null,
  };

  const [mgrSelectedFilters, setMgrSelectedFilters] = useState({
    ...EMPTY_MGR_FILTERS,
  });

  const handleMgrChange = (key, value) =>
    setMgrSelectedFilters((prev) => ({ ...prev, [key]: value }));

  const handleMgrDateRangeSelect = (ranges) => {
    setSelectionRange(ranges.selection);
    setMgrSelectedFilters((prev) => ({
      ...prev,
      start_date: ranges.selection.startDate,
      end_date: ranges.selection.endDate,
    }));
  };

  const handleMgrApply = () => {
    const f = {};
    const plain = [
      "lob_name",
      "manager_name",
      "team_lead_name",
      "agent_name",
      "dca_organization_name",
      "collection_strategy",
    ];
    plain.forEach((k) => {
      if (mgrSelectedFilters[k]) f[k] = mgrSelectedFilters[k];
    });
    if (mgrSelectedFilters.start_date)
      f.from_date = formatDate(mgrSelectedFilters.start_date);
    if (mgrSelectedFilters.end_date)
      f.to_date = formatDate(mgrSelectedFilters.end_date);
    props.changeSideBarWidth();
    if (props.onApplyFilter) props.onApplyFilter(f);
  };

  const handleMgrReset = () => {
    setMgrSelectedFilters({ ...EMPTY_MGR_FILTERS });
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    });
    props.changeSideBarWidth();
    if (props.onresetFilter) props.onresetFilter();
  };

  const FIELD_OPTIONS = {
    organization: apiFilters.lob,
    manager: apiFilters.manager,
    team_lead: apiFilters.teamLead,
    agent: apiFilters.agent,
  };

  const HIERARCHY_LABELS = {
    organization: "LOB Head / VP Collections",
    manager: "Manager",
    team_lead: "Team Lead",
    agent: "Agent",
  };

  const Footer = ({ onReset, onApply }) => (
    <div
      className="w-full fixed right-0 bottom-0 bg-white py-2"
      style={{
        zIndex: "5000",
        width: props.width,
        height: "46px",
        transition: "0.5s",
      }}
    >
      <div className="px-8">
        <button
          className="btn Save"
          style={{ backgroundColor: "rgb(249, 158, 82)", color: "white" }}
          type="button"
          onClick={onReset}
        >
          Reset
        </button>
        <button
          className="btn Save ml-4"
          style={{ backgroundColor: "#271078", color: "white" }}
          type="button"
          onClick={onApply}
        >
          Apply
        </button>
      </div>
    </div>
  );

  const panelStyle = {
    height: "100%",
    width: props.width,
    position: "fixed",
    zIndex: "2000",
    top: "0",
    right: "0",
    backgroundColor: "#DEE3E8",
    transition: "0.5s",
    overflowX: "hidden",
    paddingBottom: "60px",
  };

  if (isAgentRole) {
    return (
      <div>
        <div className="filterDiv overflow-y-auto" style={panelStyle}>
          <div style={{ padding: "4px" }}>
            <DateRangePicker
              ranges={[selectionRange]}
              onChange={handleAgentDateRangeSelect}
            />

            <div className="mt-6" style={{ paddingBottom: "1px" }}>
              <div
                className="my-calls-column"
                style={{ maxHeight: "200px", overflowY: "auto" }}
              >
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-col clearfix">
                      <p className="blue">Customer</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {filterData ? (
                    filterData.customers?.map((customer, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="select-check">
                          <label
                            className="checkbox-container"
                            style={{ fontSize: "15px" }}
                          >
                            {customer[0].toUpperCase() +
                              customer.slice(1).toLowerCase()}
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleCheckboxChange("customer", customer)
                              }
                              checked={agentSelectedFilters.customer.includes(
                                customer,
                              )}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="px-8">No customer available</div>
                  )}
                </div>
              </div>
            </div>

            <div className="" style={{ paddingBottom: "1px" }}>
              <div className="my-calls-column">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-col clearfix">
                      <p className="blue">Agents</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {filterData ? (
                    filterData.reporters.map((agent, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="select-check">
                          <label
                            className="checkbox-container"
                            style={{ fontSize: "15px" }}
                          >
                            {agent[0].toUpperCase() +
                              agent.slice(1).toLowerCase()}
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleCheckboxChange("agent", agent)
                              }
                              checked={agentSelectedFilters.agent.includes(
                                agent,
                              )}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="px-8">No reporters available</div>
                  )}
                </div>
              </div>
            </div>

            <div className="" style={{ paddingBottom: "1px" }}>
              <div className="my-calls-column">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-col clearfix">
                      <p className="blue">Products</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {filterData &&
                    filterData.products.map((product, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="select-check">
                          <label
                            className="checkbox-container"
                            style={{ fontSize: "15px" }}
                          >
                            {product
                              .split(" ")
                              .map(
                                (w) =>
                                  w.charAt(0).toUpperCase() +
                                  w.slice(1).toLowerCase(),
                              )
                              .join(" ")}
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleCheckboxChange("product", product)
                              }
                              checked={agentSelectedFilters.product.includes(
                                product,
                              )}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="" style={{ paddingBottom: "1px" }}>
              <div className="my-calls-column">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-col clearfix">
                      <p className="blue">Sentiment</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {filterData &&
                    filterData.sentiment.map((sentiment, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="select-check">
                          <label
                            className="checkbox-container"
                            style={{ fontSize: "15px" }}
                          >
                            {sentiment[0].toUpperCase() +
                              sentiment.slice(1).toLowerCase()}
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleCheckboxChange("sentiment", sentiment)
                              }
                              checked={agentSelectedFilters.sentiment.includes(
                                sentiment,
                              )}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="" style={{ paddingBottom: "1px" }}>
              <div className="my-calls-column">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-col clearfix">
                      <p className="blue">Intent</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {filterData &&
                    filterData.intent.map((intent, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="select-check">
                          <label
                            className="checkbox-container"
                            style={{ fontSize: "15px" }}
                          >
                            {intent[0].toUpperCase() +
                              intent.slice(1).toLowerCase()}
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleCheckboxChange("intent", intent)
                              }
                              checked={agentSelectedFilters.intent.includes(
                                intent,
                              )}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="" style={{ paddingBottom: "1px" }}>
              <div className="my-calls-column">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-col clearfix">
                      <p className="blue">Pitch Variance</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {filterData &&
                    filterData.pitch.map((pitch, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="select-check">
                          <label
                            className="checkbox-container"
                            style={{ fontSize: "15px" }}
                          >
                            {pitch[0].toUpperCase() +
                              pitch.slice(1).toLowerCase()}
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleCheckboxChange("pitch_variance", pitch)
                              }
                              checked={agentSelectedFilters.pitch_variance.includes(
                                pitch,
                              )}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="" style={{ paddingBottom: "1px" }}>
              <div className="my-calls-column">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-col clearfix">
                      <p className="blue">Agreeability</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
                    <div className="col-sm-12">
                      {filterData && (
                        <RangeSlider
                          defaultValue={0}
                          min={filterData.aggreability?.min}
                          max={filterData.aggreability?.max}
                          step={1}
                          onChange={(val) =>
                            handleSliderChange("aggreeability", val)
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-20" style={{ paddingBottom: "1px" }}>
              <div className="my-calls-column">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-col clearfix">
                      <p className="blue">Loudness</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
                    <div className="col-sm-12">
                      {filterData && (
                        <RangeSlider
                          defaultValue={0}
                          min={filterData.loudness?.min}
                          max={filterData.loudness?.max}
                          step={100}
                          onChange={(val) =>
                            handleSliderChange("loudness", val)
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer onReset={handleAgentReset} onApply={handleAgentApply} />
      </div>
    );
  }

  return (
    <div>
      <div className="filterDiv overflow-y-auto" style={panelStyle}>
        <div style={{ padding: "10px 10px 0" }}>
          {visibleHierarchyFields.length > 0 && (
            <div style={CARD_STYLE}>
              <p style={CARD_HEADING_STYLE}>Organization Filters</p>
              {visibleHierarchyFields.map(({ key, apiField }) => (
                <SelectField
                  key={key}
                  label={HIERARCHY_LABELS[key] || "Organization"}
                  filterKey={apiField}
                  options={FIELD_OPTIONS[key]}
                  value={mgrSelectedFilters[apiField]}
                  onChange={handleMgrChange}
                />
              ))}
            </div>
          )}

          {!isAgentRole && (
            <div style={CARD_STYLE}>
              <p style={CARD_HEADING_STYLE}>DCA</p>
              <SelectField
                label="DCA"
                filterKey="dca_organization_name"
                options={apiFilters.dcaOrganization}
                value={mgrSelectedFilters.dca_organization_name}
                onChange={handleMgrChange}
              />
            </div>
          )}

          <div style={CARD_STYLE}>
            <p style={CARD_HEADING_STYLE}>Call Details</p>
            <SelectField
              label="Call Status"
              filterKey="collection_strategy"
              options={apiFilters.collectionStrategy}
              value={mgrSelectedFilters.collection_strategy}
              onChange={handleMgrChange}
            />
          </div>

          <div style={CARD_STYLE}>
            <p style={CARD_HEADING_STYLE}>Date Range</p>
            <div className="" style={{ paddingBottom: "4px" }}>
              <div className="my-calls-column">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-col clearfix">
                      <p className="blue">Custom Date Range</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ overflowX: "auto" }}>
              <DateRangePicker
                ranges={[selectionRange]}
                onChange={handleMgrDateRangeSelect}
                showMonthAndYearPickers={false}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer onReset={handleMgrReset} onApply={handleMgrApply} />
    </div>
  );
};

export default Filter;
